import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ShowBrand from "../../../components/SuperAdmin/Brand/ShowBrand";

export default withRouter(connect()(ShowBrand));
